import { render, staticRenderFns } from "./SetSubmitCate.vue?vue&type=template&id=57a07a81"
import script from "./SetSubmitCate.vue?vue&type=script&lang=js"
export * from "./SetSubmitCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports